"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
var extname = function (path) {
    var lastDot = path.lastIndexOf(".");
    if (lastDot > 0 && lastDot < path.length - 1) {
        return path.substring(lastDot + 1);
    }
    else {
        return "";
    }
};
var remoteFormatsForAsset = function (args) {
    var setType = args.setType, assetData = args.assetData;
    var hasVectorSource = function (assetData) {
        return (assetData.file &&
            constants_1.remoteVectorImageFormatExtensions.includes(extname(assetData.file.default)));
    };
    if ((setType === "illustrations" || setType === "images") &&
        (!!assetData.rasterizationSizes || !hasVectorSource(assetData))) {
        return [constants_1.remoteImageFormatPNG, constants_1.remoteImageFormatWEBP];
    }
    else if ((setType === "icons" ||
        setType === "illustrations" ||
        setType === "images") &&
        hasVectorSource(assetData)) {
        return [constants_1.remoteImageFormatSVG, constants_1.remoteImageFormatXML];
    }
    else if (setType === "fonts" && assetData.file) {
        return [constants_1.remoteFontFormatWOFF];
    }
    return [];
};
exports.default = remoteFormatsForAsset;
